module.exports = __webpack_public_path__ + "static/media/sven.5ef121d3.jpg";